import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './i18n';
import { createMetaManager } from 'vue-meta';

const app = createApp(App);
const metaManager = createMetaManager();

app.use(router);
app.use(i18n);
app.use(metaManager);
app.mount('#app');
